import React from 'react'
import { useCompumaticClockPunchesWorkflowsContextValue } from '../../context/CompumaticClockPunchesWorkflowsProvider'
import { EditCompumaticPunchFlowMain } from './components/EditCompumaticPunchFlowMain'

export const EditCompumaticPunchFlow = () => {
  const {
    editPunchFlow: { punch },
  } = useCompumaticClockPunchesWorkflowsContextValue()

  if (punch === null) {
    return null
  }

  return <EditCompumaticPunchFlowMain punch={punch} />
}
